import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";

productPartNumbersStyles.erpNumberLabelText = {
  weight: "normal"
}

productPartNumbersStyles.erpNumberValueText = {
  weight: "bold"
}

productPartNumbersStyles.manufacturerItemLabelText = {
  weight:"normal"
}
productPartNumbersStyles.manufacturerItemValueText={
  weight:"bold"
}